import React, { useEffect, useState } from "react";

import {
  BuildingOffice2Icon,
  ChartPieIcon,
  ClipboardDocumentCheckIcon,
  CalendarDaysIcon,
  UsersIcon,
  ClockIcon,
} from "@heroicons/react/20/solid";
import { Link, Outlet, useNavigate } from "react-router-dom";

const tabs = [
  {
    name: "Calendar",
    to: "",
    icon: CalendarDaysIcon,
    current: true,
  },
  { name: "Schedules", to: "schedules", icon: ClipboardDocumentCheckIcon },
  { name: "Employees", to: "employees", icon: UsersIcon },
  { name: "Shifts", to: "shifts", icon: ClockIcon },
  { name: "Departments", to: "departments", icon: BuildingOffice2Icon },
  { name: "Reports", to: "reports", icon: ChartPieIcon },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Detail = () => {
  const currentPath = window.location.pathname;

  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("logged-in-as") == "client") {
      navigate("/client");
    }

    if (
      !localStorage.getItem("companyName") ||
      !localStorage.getItem("code") ||
      !localStorage.getItem("clientId") ||
      !localStorage.getItem("companyId")
    ) {
      navigate("/admin");
    }
  }, []);

  const segments = currentPath.split("/");
  let lastSegment = segments.pop();

  if (lastSegment === "client-detail") lastSegment = "";

  const [activeTab, setActiveTab] = useState(lastSegment);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row mb-4  ">
        <h1 className="text-2xl font-bold text-indigo-500">
          {localStorage.getItem("companyName")}
        </h1>
      </div>
      <div className="mb-5">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <Link
                key={tab.name}
                to={tab.to}
                className={classNames(
                  activeTab === tab.to
                    ? "border-indigo-500 text-indigo-600"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                  "group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium"
                )}
                onClick={() => setActiveTab(tab.to)}
              >
                <tab.icon
                  className={classNames(
                    activeTab === tab.to
                      ? "text-indigo-500"
                      : "text-gray-400 group-hover:text-gray-500",
                    "-ml-0.5 mr-2 h-5 w-5"
                  )}
                />
                <span>{tab.name}</span>
              </Link>
            ))}
          </nav>
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default Detail;
